module.exports = __webpack_public_path__ + "static/media/corporate-schedule.3a4af9c7.png";